/**
 * To meet sonarqube-gate standards the icons have been broken out into files
 * less than 1000 line of code. To add more icons start by adding to last
 * file. Once that file is close to 1000 lines of code create a new file.
 */
import partOne from "./icons/partOne";
import partTwo from "./icons/partTwo";
import partThree from "./icons/partThree";
import partFour from "./icons/partFour";
import partFive from "./icons/partFive";
import partSix from "./icons/partSix";

const iconset = Object.assign(
  partOne,
  partTwo,
  partThree,
  partFour,
  partFive,
  partSix
);

export default iconset;
